import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Icon } from '.';
import { IconsMap } from '.';
import { WrapperHorizontal } from '../../gatsby-theme-docz/components/Wrapper';
export const supportedNames = Object.keys(IconsMap);
export const _frontmatter = {};
const layoutProps = {
  supportedNames,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "icon"
    }}>{`Icon`}</h1>
    <p>{`Icon component provides set of basic svg icons commonly used in web apps`}</p>
    <h2 {...{
      "id": "supported-icons"
    }}>{`Supported Icons`}</h2>
    <p>{`Name of specific icon is in title of each icon - just hover icon to see its name`}</p>
    <Playground __position={0} __code={'<WrapperHorizontal>\n  {supportedNames.map(name => (\n    <Icon name={name} title={name} key={name} />\n  ))}\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Icon,
      IconsMap,
      WrapperHorizontal,
      DefaultLayout,
      supportedNames,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        {supportedNames.map(name => <Icon name={name} title={name} key={name} mdxType="Icon" />)}
    </WrapperHorizontal>
    </Playground>
    <h2 {...{
      "id": "rotating-prop"
    }}>{`Rotating prop`}</h2>
    <p>{`Make css animation of rotating icon... use wisely, propably only for `}<inlineCode parentName="p">{`loading`}</inlineCode>{` icon`}</p>
    <Playground __position={1} __code={'<Icon name={\'loading\'} isRotating />\n<Icon name={\'edit\'} isRotating />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Icon,
      IconsMap,
      WrapperHorizontal,
      DefaultLayout,
      supportedNames,
      _frontmatter
    }} mdxType="Playground">
    <Icon name={'loading'} isRotating mdxType="Icon" />
    <Icon name={'edit'} isRotating mdxType="Icon" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      